import React from "react";
import PromptModal from "src/components/ConfirmationModal/PromptModalV2";
import * as S from "src/constants/StringConstants";
import { IOption } from "src/store/models/option.model";
import { BrokerContractsForm } from "./BrokerContractsForm";

interface ContractingModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isEdit?: boolean;
  selectCarrierList: IOption[];
  selectStatusTypeList: IOption[];
  form: any;
  formProps: any;
}

export const ContractingModal: React.FC<ContractingModalProps> = ({
  open,
  onClose,
  onConfirm,
  isEdit,
  selectCarrierList,
  selectStatusTypeList,
  form,
  formProps,
}) => {
  return (
    <PromptModal
      width="60rem"
      open={open}
      onConfirm={onConfirm}
      onReject={onClose}
      title={isEdit ? S.BRO_CONTRACTING_MODAL_TITLE_EDIT : S.BRO_CONTRACTING_MODAL_TITLE}
      confirmText={S.BRO_CONTRACTING_SAVE}
      rejectText={S.UDM_CANCEL_BUTTON}>
      <form onSubmit={onConfirm}>
        <BrokerContractsForm
          form={form}
          formProps={formProps}
          selectCarrierList={selectCarrierList}
          selectStatusTypeList={selectStatusTypeList}
        />
      </form>
    </PromptModal>
  );
};

export default ContractingModal;
